import axios from 'axios';
import { axiosInstance } from '../Axios';
import { loader, storeData } from './UiReducer';
const { createSlice } = require('@reduxjs/toolkit');

const BusReducer = createSlice({
	name: 'Bus',
	initialState: {
		success: false,
		error: null,
		loading: false,
		buscity: null,
		busSearch: null,
	},
	reducers: {
		cityBusRequest(state, action) {
			state.loading = true;
		},
		cityBusSuccess(state, action) {
			state.loading = false;
			state.buscity = action.payload;
			state.error = null;
		},
		cityBusFail(state, action) {
			state.loading = false;
			state.error = action.payload;
		},
		busSearchRequest(state, action) {
			state.loading = true;
		},
		busSearchSuccess(state, action) {
			state.loading = false;
			state.busSearch = action.payload;
			state.error = null;
		},
		busSearchFail(state, action) {
			state.loading = false;
			state.error = action.payload;
		},
	},
});

const { actions } = BusReducer;

export const {
	cityBusRequest,
	cityBusSuccess,
	cityBusFail,
	busSearchRequest,
	busSearchSuccess,
	busSearchFail,
} = actions;

export const fetchBusCityDispatch = (body) => async (dispatch) => {
	try {
		dispatch(cityBusRequest());
		const config = {
			headers: {
				Accept: 'application/json',
				'Client-Service': 'srk-client',
				'Auth-Key': 'srkapi',
			},
		};
		const { data } = await axios.post(
			'BusTbo/buscity',
			body,
			config
		);
		console.log(data);
		dispatch(cityBusSuccess(data));
	} catch (error) {
		dispatch(
			cityBusFail(
				error.response && error.response.data.message
					? error.response.data.message
					: error.message
			)
		);
	}
};

export const fetchBusSearchDispatch = (bodyData) => async (dispatch) => {
	try {
		dispatch(busSearchRequest());
		const config = {
			headers: {
				Accept: 'application/json',
				'Client-Service': 'srk-client',
				'Auth-Key': 'srkapi',
				'Databse-Name': 'flightsafirbaz_apipartner',
				'User-Name': 'flightsafirbaz_username',
				'Pass-Word': 's0fF#*786',
			},
		};
		const { data } = await axios.post(
			'https://flight.musafirbazar.com/api/BusSeat/bussearch',
			bodyData,
			config
		);
		console.log(data);
		dispatch(busSearchSuccess(data));
	} catch (error) {
		dispatch(
			busSearchFail(
				error.response && error.response.data.message
					? error.response.data.message
					: error.message
			)
		);
	}
};
export default BusReducer;
